import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    gap: 1rem;
    padding: 1rem .5rem .5rem .5rem;
`

export const CustomButton = styled(ButtonMui)`
    width: 50%;    
    height: 2.5rem !important;
    margin: 0 !important;
`
